import ProductCard, { ProductCardInner } from './ProductCard';
import FreeShippingCard, { FreeShippingCardInner } from './FreeShippingCard';
import ServiceCard, { ServiceCardInner } from './ServiceCard';
import MultipleProductCard from './MultipleProductCard';
import { Offer as TOffer, Settings } from '../domain';

interface Props {
  offer: TOffer;
  withoutCard: boolean;
  settings: Settings;
}

export default ({ offer, withoutCard, settings }: Props) => {
  switch (offer.type) {
    case 'ProductOffer':
      return withoutCard ? (
        <ProductCardInner offer={offer} />
      ) : (
        <ProductCard offer={offer} settings={settings} />
      );
    case 'ServiceOffer':
      return withoutCard ? (
        <ServiceCardInner offer={offer} />
      ) : (
        <ServiceCard offer={offer} settings={settings} />
      );
    case 'FreeShippingOffer':
      return withoutCard ? (
        <FreeShippingCardInner offer={offer} />
      ) : (
        <FreeShippingCard offer={offer} settings={settings} />
      );
    case 'MultipleProductOffer':
      return <MultipleProductCard offer={offer} />;
    default:
      throw Error('unknown offer type');
  }
};
